import { FileObject } from '@/constants/types';

/**
 * Extracts URL from FileObject or returns the string if it's already a URL
 */
export const getFileUrl = (file: string | FileObject | undefined | null): string => {
  if (!file) return '';
  if (typeof file === 'string') return file;
  return file.url || '';
};

/**
 * Extracts file ID from FileObject or returns the string if it's already an ID
 */
export const getFileId = (file: string | FileObject | undefined | null): string => {
  if (!file) return '';
  if (typeof file === 'string') return file;
  return file._id || '';
};

/**
 * Extracts file name from FileObject
 */
export const getFileName = (file: string | FileObject | undefined | null): string => {
  if (!file) return '';
  if (typeof file === 'string') return '';
  return file.originalName || '';
};
